<template>
  <div>
    <div>
      <dl class="mt-6 space-y-4 px-4">
        <div v-for="outage in outages" :key="outage.id" class="relative text-left pr-14 border border-solid border-black rounded-lg px-6 py-6">
          <dt class="flex flex-col text-left">
            <p class="text-lg pt-1 leading-6 font-poppins text-black py-0 my-0">{{ outage.title }}</p>
            <p class="text-md leading-6 font-poppins text-black font-bold py-1 my-0">Network - {{ outage.network }}</p>
          </dt>
          <dd class="font-poppins text-black py-0 my-0">
            {{ outage.status }}
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script setup lang="ts">
import { OutageData } from '@/services/integration/clients/types';
import { defineProps } from 'vue';

type OutagesList = {
  outages: Array<OutageData> | null
}

defineProps<OutagesList>();

</script>
